import styled from 'styled-components'

export const IconWrapper = styled.div`
  width: 50px;
  height: 50px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.theme.icon.color};

  @media (min-width: 768px) {
    height: 60px;
  }
`
